(function () {
  angular
    .module("akitabox.ui.dialogs.document.revert")
    .factory("RevertDocumentDialog", RevertDocumentDialog);

  /* @ngInject */
  function RevertDocumentDialog($log, $q, $mdDialog, $mdMedia) {
    var modal = {
      templateUrl:
        "app/core/ui/dialogs/document/revert/revert-file.dialog.html",
      controller: "RevertDocumentDialogController",
      controllerAs: "dialog",
      bindToController: true,
      parent: angular.element(document.body),
      closeTo: angular.element(document.body),
      clickOutsideToClose: false,
      escapeToClose: false,
      focusOnOpen: false,
    };

    // Enable fullscreen mode while on mobile
    if ($mdMedia("sm") || $mdMedia("xs")) {
      modal.fullscreen = true;
    }

    var service = {
      show: show,
    };

    return service;

    // ------------------------
    //   Public Functions
    // ------------------------

    /**
     * Show dialog, `options.locals.documentIDs` and `options.locals.building` are required
     *
     * @param  {Object}                 options     Dialog options
     * @return {Promise<Object|Error}               Promise that resolves with the reverted document
     */
    function show(options) {
      // Verify we have documentIDs and building locals
      if (
        !options ||
        !options.locals ||
        !options.locals.document ||
        !options.locals.commitId ||
        !options.locals.building
      ) {
        $log.error(
          "RevertDocumentDialog: you must pass a document, commitId and building via locals"
        );
        return $q.reject("Sorry, we weren't able to complete your request.");
      }
      var dialogOptions = angular.extend({}, modal, options);
      return $mdDialog.show(dialogOptions);
    }
  }
})();
